const { get, isString } = require("lodash");
const { REGEX, STRINGS } = require("../constants");

const BIC7_OPTIONS = {
  A: "([A-Z])",
  B: "([A-Z])",
  N: "([0-9])",
  O: "([0-9])",
  "?": "([A-Z])([0-9])",
  X: "([A-Z])([0-9])",
};

const generateRegexForBIC7PostCodePattern = (bic7PostCodePattern = "") => {
  const regex = Array.from(bic7PostCodePattern).reduce(
    (acc, char) => (acc += BIC7_OPTIONS[char]),
    "^"
  );
  return regex.concat("$");
};

const generateRegexPatterns = (postcodePattern) => {
  const patterns = !Array.isArray(postcodePattern)
    ? postcodePattern.split(",")
    : postcodePattern;

  return patterns
    .filter((pattern) => isString(pattern))
    .map((pattern) => generateRegexForBIC7PostCodePattern(pattern));
};

const validateInternationalPostcodeWithPatterns = (
  postcodePattern,
  postcodeValue
) => {
  const regexPatterns = generateRegexPatterns(postcodePattern);
  return regexPatterns.some((pattern) => RegExp(pattern).test(postcodeValue));
};

const validateInternationalPostcode = ({
  postcodeValue,
  countryCode,
  postcodePattern,
}) => {
  if (
    countryCode === STRINGS.US &&
    postcodeValue.match(REGEX.FIRST_TWO_CHARACTERS)
  ) {
    const postcodeWithoutFirstTwoCharacters = postcodeValue.substring(2);
    return validateInternationalPostcodeWithPatterns(
      postcodePattern,
      postcodeWithoutFirstTwoCharacters
    );
  }

  const postcodeWithoutCountryCode = postcodeValue.startsWith(countryCode)
    ? postcodeValue.substring(2)
    : postcodeValue;
  return validateInternationalPostcodeWithPatterns(
    postcodePattern,
    postcodeWithoutCountryCode
  );
};

const isPostcodeValid = (postcode, countryValue) => {
  if (!postcode || !countryValue) {
    return false;
  }

  const flagPostCodeNo = get(countryValue, "flagPostCodeNo", "");
  const countryCode = get(countryValue, "countryKey", "");
  const postcodePattern = get(countryValue, "postcodePattern", "");

  if (
    !postcodePattern?.length ||
    postcodePattern.includes("") ||
    flagPostCodeNo
  ) {
    // skip validation if there is no available postcode validation pattern or flagPostCodeNo === true
    return true;
  }

  if (countryCode === STRINGS.GB) {
    return REGEX.GB_POSTCODE_PATTERN.test(postcode);
  }

  if (countryCode === STRINGS.IE) {
    return REGEX.IE_POSTCODE_PATTERN.test(postcode);
  }

  return validateInternationalPostcode({
    postcodeValue: postcode,
    countryCode,
    postcodePattern,
  });
};

module.exports = {
  generateRegexForBIC7PostCodePattern,
  generateRegexPatterns,
  validateInternationalPostcodeWithPatterns,
  validateInternationalPostcode,
  isPostcodeValid,
};
